import { MattersListView } from "@/components/features/matters/MattersListView";
import { GlobalNotAuthorized, Text } from "@/components/ui";
import { useUser } from "@/components/UserProvider";
import { PAGE_PERMISSION_KEYS } from "@/lib/data/static/permissionOptions";
import { tanstackTableNames } from "@/lib/data/static/tanstack-table-names";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/reports/closed-matters")({
  component: RouteComponent,
});

function RouteComponent() {
  const { hasPagePermission } = useUser();

  if (!hasPagePermission(PAGE_PERMISSION_KEYS.mattersClosed)) {
    return <GlobalNotAuthorized />;
  }

  return (
    <MattersListView
      embedded
      searchItemType="closedMatters"
      showCreateMatter={false}
      showDroppedDateColumn
      showStatusStartedFilter
      showTour={false}
      statusCategories={["closed"]}
      tableName={tanstackTableNames.reportsClosedMatters}
      topContent={
        <div className="pb-6">
          <Text variant="title">Closed matters report</Text>
        </div>
      }
    />
  );
}
